import AppointmentStatus from "./AppointmentStatus";
import {PollItem} from "./PollItem";
import {getUniqueDates} from "../utils/Utils";

export class UserAppointment {
    id: string; // appointmentId
    name: string;
    type: string;
    status: AppointmentStatus;
    pollItems: PollItem[];
    role: string;

    constructor(id: string, name: string, type: string, status: AppointmentStatus, pollItems: PollItem[], role: string) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.status = status;
        this.pollItems = pollItems;
        this.role = role;
    }

    static fromJson(data: any): UserAppointment {
        return new UserAppointment(
            data.id,
            data.name,
            data.type,
            data.status,
            data.pollItems.map((pollItemData: any) => PollItem.fromJson(pollItemData)),
            data.role
        )
    }

    getPollDateFirstDate(): Date | null {
        const uniqueDates = this.getSortedPollItemDates();
        return uniqueDates[0];
    }

    getPollDateLastDate(): Date | null {
        const uniqueDates = this.getSortedPollItemDates();
        return uniqueDates[uniqueDates.length - 1];
    }

    private getSortedPollItemDates(): Date[] {
        if (this.pollItems.length === 0) {
            return [];
        }

        if (this.pollItems.length === 1) {
            return [this.pollItems[0].date];
        }

        const dates = this.pollItems.map((pollItem) => pollItem.date);
        const uniqueDates = getUniqueDates(dates);

        return uniqueDates.sort((a, b) => a.getTime() - b.getTime())
    }
}